export default __webpack_public_path__ + "static/media/pagebanner7.64bf71c3.jpg";